<template>
  <v-container>
    <div class="sign-pg">
      <div class="sign-row">
        <div class="sign-form-top">
          <h2>{{ $t('Cоздать аккаунт') }}</h2>
        </div>
        <form class="register-form" @submit.prevent="register">
          <div class="form-group">
            <input
              id="firstName"
              name="firstName"
              type="text"
              v-model.trim="firstName"
              class="form-control"
              :class="{
              invalid: $v.firstName.$dirty && !$v.firstName.required
            }"
              placeholder="Фамилия"
            />
            <small
              class="helper-text invalid"
              v-if="$v.firstName.$dirty && !$v.firstName.required"
            >
              {{ $t('Поле фамилия не должно быть пустым') }}
            </small>
          </div>
          <div class="form-group">
            <input
              id="secondName"
              type="text"
              v-model.trim="secondName"
              class="form-control"
              :class="{
              invalid: $v.secondName.$dirty && !$v.secondName.required
            }"
              placeholder="Имя"
            />
            <small
              class="helper-text invalid"
              v-if="$v.secondName.$dirty && !$v.secondName.required"
            >
              {{ $t('Поле имя не должно быть пустым') }}
            </small>
          </div>
          <div class="form-group">
            <input
              id="lastName"
              type="text"
              v-model.trim="lastName"
              class="form-control"
              placeholder="Отчество"
            />
          </div>
          <div class="form-group">
            <input
              id="email"
              type="text"
              v-model.trim="email"
              class="form-control"
              :class="{
              invalid:
                ($v.email.$dirty && !$v.email.required) ||
                ($v.email.$dirty && !$v.email.email)
            }"
              placeholder="Email"
            />
            <small
              class="helper-text invalid"
              v-if="$v.email.$dirty && !$v.email.required"
            >
              {{ $t('Поле Email не должно быть пустым') }}
            </small>
            <small
              class="helper-text invalid"
              v-else-if="$v.email.$dirty && !$v.email.email"
            >
              {{ $t('Некорректный адрес email, попробуйте еще раз') }}
            </small>
          </div>
          <div class="form-group">
            <input
              id="password"
              type="password"
              v-model.trim="password"
              class="form-control"
              :class="{
              invalid:
                ($v.password.$dirty && !$v.password.required) ||
                ($v.password.$dirty && !$v.password.minLength)
            }"
              :placeholder="$t('Пароль')"
            />
            <small
              class="helper-text invalid"
              v-if="$v.password.$dirty && !$v.password.required"
            >
              {{ $t('Пароль должен содержать букву') }}
            </small>
            <small
              class="helper-text invalid"
              v-else-if="$v.password.$dirty && !$v.password.minLength"
            >
              {{ $t('Пароль должен быть') }}
              {{ $v.password.$params.minLength.min }} {{ $t('символов') }}. {{ $t('Сейчас он') }}
              {{ password.length }}
            </small>
          </div>
          <div class="form-group">
            <input
              id="repeatPassword"
              type="password"
              v-model.trim="repeatPassword"
              class="form-control"
              :class="{
                invalid:
                  ($v.password.$dirty && !$v.password.required) ||
                  ($v.repeatPassword.$dirty && password !== repeatPassword)
              }"
              :placeholder="$t('Повторите пароль')"
            />
            <small
              class="helper-text invalid"
              v-if="$v.repeatPassword.$dirty && password !== repeatPassword"
            >
              {{ $t("Пароли должны совпадать") }}
            </small>
          </div>
          <div class="form-captcha">
            <vue-recaptcha
              ref="recaptcha"
              size="invisible"
              :sitekey="sitekey"
              @verify="register"
              @expired="onCaptchaExpired"
            />
          </div>
          <button type="submit" class="btn btn-default green">
            {{ $t('Зарегистрироваться') }}
          </button>
          <div class="sign-form-bottom">
            <p>
              <small>
                {{ $t('Регистрируясь вы принимаете') }}
                <a href="#">{{ $t('Условия соглашения') }}</a>
              </small>
            </p>
          </div>
        </form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { email, required, minLength, sameAs } from 'vuelidate/lib/validators'
import VueRecaptcha from 'vue-recaptcha'
import messages from '@/utils/messages'
import { mapMutations } from 'vuex'

export default {
  name: 'register',
  components: {
    VueRecaptcha
  },
  data: () => ({
    firstName: '',
    secondName: '',
    lastName: '',
    email: '',
    password: '',
    repeatPassword: '',
    userId: '',
    sitekey: '6LfkaOYUAAAAAHlcKifbIYWE3hdoj96TBA9mY1mF'
  }),
  validations: {
    firstName: { required },
    secondName: { required },
    lastName: {},
    email: {
      email,
      required
    },
    password: {
      required,
      minLength: minLength(8)
    },
    repeatPassword: {
      sameAsPassword: sameAs('password')
    }
  },
  mounted () {
    if (messages[this.$route.query.message]) {
      this.$message(messages[this.$route.query.message])
    }
  },
  created () {
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    persist () {
      localStorage.setItem('email', this.$event.target.value)
    },
    register (recaptchaToken) {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return this.$refs.recaptcha.execute()
      }
      this.setLoading(true)
      const registerData = {
        firstName: this.firstName,
        secondName: this.secondName,
        lastName: this.lastName,
        email: this.email,
        pass: this.password,
        userId: this.userId,
        recaptchaToken: recaptchaToken
      }

      this.$store
        .dispatch('register', registerData)
        .then(() => {
          this.$router.push('/success-register')
          this.setLoading(false)
        })
        .catch((e) => {
          this.error.push(e)
          this.setLoading(false)
        })
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    authenticate: function (provider) {
      this.$auth.link(provider).then((authResponse) => {
        if (authResponse.errors) {
          this.$noty.error(authResponse.errors)
          return
        }

        this.firstName = authResponse.user.first_name
        this.secondName = authResponse.user.second_name
        this.email = authResponse.user.email
        this.userId = authResponse.user.id
      })
    }
  }
}
</script>
